import { render, staticRenderFns } from "./BussinessAnalysis.vue?vue&type=template&id=009133b6&scoped=true&"
import script from "./BussinessAnalysis.vue?vue&type=script&lang=js&"
export * from "./BussinessAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BussinessAnalysis.vue?vue&type=style&index=0&id=009133b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009133b6",
  null
  
)

export default component.exports